export var OrbiResultsFilterEnum;
(function (OrbiResultsFilterEnum) {
    OrbiResultsFilterEnum["invalid"] = "ORFE.invalid";
    OrbiResultsFilterEnum["repoall"] = "ORFE.repoall";
    OrbiResultsFilterEnum["reposet"] = "ORFE.reposet";
    OrbiResultsFilterEnum["reposnone"] = "ORFE.reposnone";
    OrbiResultsFilterEnum["repotopic"] = "ORFE.repotopic";
    OrbiResultsFilterEnum["repolive"] = "ORFE.repolive";
    OrbiResultsFilterEnum["repocustom"] = "ORFE.repocustom";
    OrbiResultsFilterEnum["auditsecurity"] = "ORFE.auditsecurity";
    OrbiResultsFilterEnum["auditall"] = "ORFE.auditall";
    OrbiResultsFilterEnum["auditonlypass"] = "ORFE.auditonlypass";
    OrbiResultsFilterEnum["auditonlyfail"] = "ORFE.auditonlyfail";
    OrbiResultsFilterEnum["auditdontknow"] = "ORFE.auditdontknow";
    OrbiResultsFilterEnum["dateweek1"] = "ORFE.dateweek1";
    OrbiResultsFilterEnum["dateweek5"] = "ORFE.dateweek5";
    OrbiResultsFilterEnum["datecustom"] = "ORFE.datecustom";
    OrbiResultsFilterEnum["custom"] = "ORFE.custom";
    OrbiResultsFilterEnum["usersall"] = "ORFE.usersall";
    OrbiResultsFilterEnum["usersnone"] = "ORFE.usersnone";
    OrbiResultsFilterEnum["userscustom"] = "ORFE.userscustom";
    OrbiResultsFilterEnum["teamsall"] = "ORFE.teamsall";
    OrbiResultsFilterEnum["teamsnone"] = "ORFE.teamsnone";
    OrbiResultsFilterEnum["teamscustom"] = "ORFE.teamscustom";
})(OrbiResultsFilterEnum || (OrbiResultsFilterEnum = {}));
;
export var OrbiApiEntrypointKey;
(function (OrbiApiEntrypointKey) {
    OrbiApiEntrypointKey["invalid"] = "OAEK.invalid";
    OrbiApiEntrypointKey["na"] = "OAEK.na";
    OrbiApiEntrypointKey["healthcheck"] = "OAEK.healthcheck";
    OrbiApiEntrypointKey["getimporthistory"] = "OAEK.getimporthistory";
    OrbiApiEntrypointKey["getrepolist"] = "OAEK.getrepolist";
    OrbiApiEntrypointKey["searchcacherepo"] = "OAEK.searchcacherepo";
    OrbiApiEntrypointKey["searchcachepullrequest"] = "OAEK.searchcachepullrequest";
    OrbiApiEntrypointKey["searchcachecommit"] = "OAEK.searchcachecommit";
    OrbiApiEntrypointKey["searchcachecodeanalysisvulnalerts"] = "OAEK.searchcachecodeanalysisvulnalerts";
    OrbiApiEntrypointKey["searchcacherelease"] = "OAEK.searchcacherelease";
    OrbiApiEntrypointKey["searchcacheworkflow"] = "OAEK.searchcacheworkflow";
    OrbiApiEntrypointKey["webhookevents"] = "OAEK.webhookevents";
    OrbiApiEntrypointKey["exportrepos"] = "OAEK.exportrepos";
    OrbiApiEntrypointKey["searchcacheworkflowrun"] = "OAEK.searchcacheworkflowrun";
    OrbiApiEntrypointKey["accesscontrol"] = "OAEK.accesscontrol";
    OrbiApiEntrypointKey["cachedusers"] = "OAEK.cachedusers";
    OrbiApiEntrypointKey["cachedteams"] = "OAEK.cachedteams";
    OrbiApiEntrypointKey["environments"] = "OAEK.environments";
    OrbiApiEntrypointKey["secrets"] = "OAEK.secrets";
    OrbiApiEntrypointKey["auditresults"] = "OAEK.auditresults";
    OrbiApiEntrypointKey["metricdata"] = "OAEK.metricdata";
})(OrbiApiEntrypointKey || (OrbiApiEntrypointKey = {}));
;
;
export class OrbiFilterState {
    constructor(locale) {
        let dteFrom = new Date(), dteTo = new Date();
        dteFrom.setDate(dteFrom.getDate() - OrbiFilterState.Globalfilters_DateType_Default_DaysLookBack);
        this.stateVars = {
            orgName: undefined,
            locale: locale,
            repositorySelector: OrbiResultsFilterEnum.repoall,
            repositorySelectorCustomValue: undefined,
            auditfocusSelector: OrbiResultsFilterEnum.auditall,
            auditfocusSelectorCustomValue: undefined,
            dateSelector: OrbiResultsFilterEnum.dateweek1,
            extraParamsNameValues: [],
            fromDate: dteFrom,
            toDate: dteTo
        };
    }
    static encodeQueryArgDate(arg, includeTime = false) {
        let r;
        let dteToConvert = undefined;
        if (arg instanceof Date && !isNaN(arg.getTime())) {
            dteToConvert = arg;
        }
        else {
            if ('string' == typeof arg) {
                let dateObj = new Date(arg);
                if (!isNaN(dateObj.getTime())) {
                    dteToConvert = dateObj;
                }
            }
        }
        if (dteToConvert instanceof Date) {
            r = includeTime ? dteToConvert.toISOString() : dteToConvert.toISOString().split('T')[0];
        }
        else {
            r = '';
        }
        return r;
    }
    ;
    static decodeQueryArgDate(strDate) {
        let r = undefined;
        let minLenIsoDate = 9;
        let maxLenIsoDate = 32;
        if (strDate && strDate.length > minLenIsoDate && strDate.length <= maxLenIsoDate) {
            r = new Date(strDate);
        }
        else {
            r = undefined;
        }
        return r;
    }
    ;
    validateArgs() {
        let someProblem = false;
        if (someProblem) {
        }
        return true;
    }
    static isValidLocale(errHandler, localeStr) {
        let isOk = "string" == typeof localeStr && localeStr.length > 0 && localeStr.length < OrbiFilterState.individualArgMaxLength;
        return isOk;
    }
    static isValidOrgname(errHandler, orgName) {
        let isOk = "string" == typeof orgName && orgName.length > 0 && orgName.length < OrbiFilterState.individualArgMaxLength;
        return isOk;
    }
    hasValidOrgname() {
        class X {
            logMessage(argName, msg) { }
            logInvalidArgAndThrow(argName, msg) { }
        }
        ;
        let isOk = OrbiFilterState.isValidOrgname(new X(), this.stateVars.orgName);
        return isOk;
    }
    marshallArgs(errHandler, apiEndpoint) {
        let myFilterState = this;
        let attrsCharacteristics = OrbiFilterState.urlArgAttrCharacterisitics[apiEndpoint];
        let args = [];
        let filterStateVars = this.stateVars;
        let keys = ['orgName', 'repositorySelector', 'repositorySelectorCustomValue', 'auditfocusSelector', 'auditfocusSelectorCustomValue', 'dateSelector'];
        for (let key of keys) {
            let myVal = filterStateVars[key];
            let validatedValue;
            let myAttrCharacteristics = (attrsCharacteristics) ? attrsCharacteristics[key] : undefined;
            if ("string" == typeof myVal && 0 < myVal.length) {
                if (OrbiFilterState.regExpArgValidation.test(myVal) && OrbiFilterState.individualArgMaxLength > myVal.length) {
                    validatedValue = myVal;
                }
                else {
                    console.error(`normalizeArgs - key=${key} is not a valid value, val=${myVal}`);
                }
            }
            if (validatedValue && 0 < validatedValue.length) {
                args.push(validatedValue);
            }
            else {
                if (myAttrCharacteristics && myAttrCharacteristics.required) {
                    console.error(`normalizeArgs - key=${key} is required but not provided`);
                }
                args.push(OrbiFilterState.strUndefined);
            }
        }
        let dateAttrCharacteristics = (attrsCharacteristics)
            ? [attrsCharacteristics['fromDate'], attrsCharacteristics['toDate']]
            : [{ required: false }, { required: false }];
        if (filterStateVars.fromDate || filterStateVars.toDate) {
            let dateArgs = [filterStateVars.fromDate, filterStateVars.toDate];
            for (let i = 0; i < dateArgs.length; i++) {
                let currDateArg = dateArgs[i];
                let currEncodedArg = OrbiFilterState.encodeQueryArgDate(currDateArg);
                if (!currEncodedArg && dateAttrCharacteristics[i] && dateAttrCharacteristics[i].required) {
                    console.error(`normalizeArgs - date[${i}] is required but not provided`);
                }
                args.push(currEncodedArg);
            }
        }
        else {
            let attrCharacteristicsReqDate = dateAttrCharacteristics.filter((v) => true == v.required);
            if (attrCharacteristicsReqDate.length > 0) {
                console.error(`normalizeArgs - dates are required but not provided`);
            }
            args.push(...[OrbiFilterState.strUndefined, OrbiFilterState.strUndefined]);
        }
        let extraParams = myFilterState.stateVars.extraParamsNameValues;
        if (!Array.isArray(extraParams)) {
            extraParams = [];
        }
        args.push(encodeURIComponent(JSON.stringify(extraParams)));
        let strUrlArgs = args.join('/');
        return strUrlArgs;
    }
    unmarshallArgs(errHandler) {
    }
}
OrbiFilterState.individualArgMaxLength = 128;
OrbiFilterState.totalArgsMaxLength = 1024;
OrbiFilterState.regExpArgValidation = /^[\w-\.]*$/;
OrbiFilterState.Globalfilters_DateType_Default_DaysLookBack = 7;
OrbiFilterState.strUndefined = 'undefined';
OrbiFilterState.urlArgAttrCharacterisitics = {
    [OrbiApiEntrypointKey.invalid]: undefined,
    [OrbiApiEntrypointKey.na]: undefined,
    [OrbiApiEntrypointKey.healthcheck]: undefined,
    [OrbiApiEntrypointKey.getimporthistory]: undefined,
    [OrbiApiEntrypointKey.getrepolist]: undefined,
    [OrbiApiEntrypointKey.searchcacherepo]: {
        locale: { required: true },
        orgName: { required: true },
        repositorySelector: { required: true },
        repositorySelectorCustomValue: { required: false },
        auditfocusSelector: { required: false },
        auditfocusSelectorCustomValue: { required: false },
        dateSelector: { required: false },
        fromDate: { required: true },
        toDate: { required: true },
        extraParamsNameValues: { required: false },
    },
    [OrbiApiEntrypointKey.searchcachepullrequest]: undefined,
    [OrbiApiEntrypointKey.searchcachecommit]: undefined,
    [OrbiApiEntrypointKey.searchcachecodeanalysisvulnalerts]: undefined,
    [OrbiApiEntrypointKey.searchcacherelease]: undefined,
    [OrbiApiEntrypointKey.searchcacheworkflow]: undefined,
    [OrbiApiEntrypointKey.webhookevents]: undefined,
    [OrbiApiEntrypointKey.exportrepos]: undefined,
    [OrbiApiEntrypointKey.searchcacheworkflowrun]: undefined,
    [OrbiApiEntrypointKey.accesscontrol]: undefined,
    [OrbiApiEntrypointKey.cachedusers]: undefined,
    [OrbiApiEntrypointKey.cachedteams]: undefined,
    [OrbiApiEntrypointKey.environments]: undefined,
    [OrbiApiEntrypointKey.secrets]: undefined,
    [OrbiApiEntrypointKey.auditresults]: undefined,
    [OrbiApiEntrypointKey.metricdata]: undefined
};
